// src/app/views/pages_predict_admin/survey_list/rtPrAdSurveyList.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const SurveyList_LEET = Loadable(lazy(() => import("./SurveyList_LEET")));
const SurveyList_G5 = Loadable(lazy(() => import("./SurveyList_G5")));
const SurveyList_G7 = Loadable(lazy(() => import("./SurveyList_G7")));

const rtPrAdSurveyList = [
  { path: `pre/${EXAM_TYPES.LEET.rid_cd_ext}/survey-list`, element: <SurveyList_LEET /> },
  { path: `pre/${EXAM_TYPES.G5.rid_cd_ext}/survey-list`, element: <SurveyList_G5 /> },
  { path: `pre/${EXAM_TYPES.G7.rid_cd_ext}/survey-list`, element: <SurveyList_G7 /> },
];
export default rtPrAdSurveyList;
